import { useQuery } from 'react-query';
import { getRecaptchaToken, POST } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';

export function Calendar({journeyGuid, processGuid, lngCode, rcaEnabled, executeRecaptcha, useMock}) {

  const baseApi = `${lngCode}`;
  const clientStateDataUpdate = useClientStateDataUpdate();
  return {
    useDateQuery (hasRecaptcha, calendarIds, unitId, serviceTypeId, appointmentTypeId, serviceId, customerGUID, journeyGUID,selectedSlot,selectedDate, questionAnswerDict) {
        return useQuery(['active-query', 'date'],
          ({ queryKey }) => getDates(hasRecaptcha, calendarIds, unitId, serviceTypeId, appointmentTypeId, serviceId, customerGUID, journeyGUID, selectedSlot, selectedDate, questionAnswerDict),
          { enabled: !!journeyGUID }
        );
    },
    useTimeQuery(hasRecaptcha, calendarIds, calendarIsFetching, serviceId, unitId, serviceTypeId, appointmentTypeId, selectedDate, customerGUID, journeyGUID, selectedSlot, questionAnswerDict,enabled) {
        return useQuery(['active-query', 'time', selectedDate],
        ({ queryKey }) => getSlots(hasRecaptcha, calendarIds, serviceId, unitId, serviceTypeId, appointmentTypeId, selectedDate, customerGUID, journeyGUID, selectedSlot, questionAnswerDict),
          { enabled: (!!calendarIds?.length && !calendarIsFetching && enabled && !!journeyGUID) || useMock }
        );
    }
  }

    async function getDates(hasRecaptcha,calendarIds, unitId, serviceTypeId, appointmentTypeId, serviceId, customerGUID, journeyGUID, selectedSlot,selectedDate, questionAnswerDict) {

      if(useMock){
        return Promise.resolve(() =>
        {
          return [...Array(35).keys()].reduce((o, _, i) => {
            var date = new Date();
            date.setDate(date.getDate() + i);
            return Object.assign(o, {
              [date.toISOString().split('T')[0]]: i+1
            })
          } , {})
        })
      }
      const clientStateData = {}
      const params = {};

      if (unitId) clientStateData.unitId = unitId;
      if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId;
      if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId;
      if (serviceId) clientStateData.serviceId = serviceId;
      if (customerGUID) clientStateData.customerGUID = customerGUID;
      if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict;
      if (calendarIds) clientStateData.calendarIds = calendarIds;
      if (selectedSlot) clientStateData.selectedSlot = selectedSlot;
      if (selectedDate) clientStateData.selectedDate = selectedDate;

      params.clientStateData = clientStateData ? clientStateData : null

      if (processGuid) params.processGuid = processGuid;
      if (journeyGUID) params.journeyGUID = journeyGUID;
      if (lngCode) params.lngCode = lngCode;

      const headers = (!!rcaEnabled && hasRecaptcha && getRecaptchaToken( await executeRecaptcha('dates') )) || {};

      const response = await POST(`${baseApi}/calendars/findcalendars`,  params, headers )

      if (response.clientStateData){ clientStateDataUpdate(response.clientStateData)}

      return response.calendars
    }
    async function getSlots(hasRecaptcha, calendarIds, serviceId, unitId, serviceTypeId, appointmentTypeId, selectedDate, customerGUID, journeyGUID, selectedSlot, questionAnswerDict) {

      if(useMock){
        var date = new Date();
        return Promise.resolve(() =>
        {
          let slot = 450
          return [...Array(21).keys()]
          .reduce((o, _, i) => {
            slot = slot + 30;
            return Object.assign(o, {
              [slot]:{
                date: (selectedDate && Object.keys(selectedDate)[0]) || date.toISOString().split('T')[0],
                appointmentTypeId: null,
                appointmentDuration: null,
                serviceIds: null
              }
            })
          } , {})
        })
      }

      const clientStateData = {}

      if (unitId) clientStateData.unitId = unitId;
      if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId;
      if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId;
      if (serviceId) clientStateData.serviceId = serviceId;
      if (calendarIds) clientStateData.calendarIds = calendarIds;
      if (selectedDate) clientStateData.selectedDate = selectedDate;
      if (customerGUID) clientStateData.customerGUID = customerGUID;
      if (selectedSlot) clientStateData.selectedSlot = selectedSlot;
      if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict;

      const params = {};

      params.clientStateData = clientStateData ? clientStateData : null

      if (journeyGUID) params.journeyGUID = journeyGUID;
      if (lngCode) params.lngCode = lngCode;

      const headers = !!rcaEnabled && hasRecaptcha && { headers: getRecaptchaToken( await executeRecaptcha('slots') )};
      const response = await POST(`${baseApi}/calendars/findslots`, params, headers )
      if (response.clientStateData){ clientStateDataUpdate(response.clientStateData)}
        return response.slots
    }
    }
